define('lq/events/actions/checkIn',[
    'lq/events/actions/eventAction',
    'lq/uploader'
], function (EventAction, Uploader) {
	'use strict';

	function CheckIn(eventData, eventArg) {
	    EventAction.call(this, eventData, eventArg);
	    return this;
	}

	EventAction.extend(CheckIn, EventAction);

    CheckIn.typeName = 'CheckIn';

	CheckIn.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };

	CheckIn.prototype.createEventActionRequest = function () {
        var self = this;

        return function (requestContinuation, requestCancellation) {
            new Uploader(self.piping, self.eventData.command, false)
                .toTenantUrl("DynamicContent/AddTempFile")
                .onFileUploaded(function (uploadResponse) {
                    if (!uploadResponse.success)
                        throw new Error('Upload failed.');

                    var request = {
                        eventActionType: "CheckIn",
                        morphId: self.eventData.command,
                        fileName: uploadResponse.filename,
                        tempUrl: uploadResponse.tempUrl
                    };
                    requestContinuation(request);
                })
                .onUploadFinished(function () {
                    this.piping.busyIndicator.forceHide();
                })
                .onFileUploadCancel(function () {
                    requestCancellation();
                    self.triggerEventIfEnabled('fileUploadCancelled');
                })
                .uploadSingleFile();
        };
	};

    CheckIn.prototype.execute = function (continuation, eventActionResponse) {
        if (eventActionResponse.isDirty && this.eventIsEnabled('onExecutionTrailDirty'))
            this.triggerEvent('onExecutionTrailDirty', continuation);
        else continuation();
    };

	return CheckIn;
});

